import React from 'react';
import { Box } from '@mui/material';
import { useAutoTranslation } from 'src/hooks/useTranslate';

// Said, not shown, beside a value drawn as an unsaved change (unsavedChange.js): the gold is not
// the only sign of it. Where the value is still exactly what a lab report gave, its "from the
// report" chip says the source as well.
export const UNSAVED_CHANGE_TEXT = 'Changed, not saved yet';

// Read by screen readers, not shown. Strings: in `sx` a bare 1 means 100%.
const VISUALLY_HIDDEN = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
};

export default function UnsavedChangeNote() {
  const t = useAutoTranslation();

  return (
    <Box component="span" data-testid="unsaved-change" sx={VISUALLY_HIDDEN}>
      {t(UNSAVED_CHANGE_TEXT)}
    </Box>
  );
}
